import { GameExplanationActions, GameType } from '@/components/modals/gameExplanation/Actions';
import { gameExplanationActionTypes } from '@/components/modals/gameExplanation/Constants';

export interface GameExplanationState {
	open: boolean;
	gameType?: GameType;
}

const initialState: GameExplanationState = {
	open: false,
	gameType: undefined,
};

export default function gameExplanationReducer(
	state = initialState,
	action: GameExplanationActions,
): GameExplanationState {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case gameExplanationActionTypes.SET_GAME_EXPLANATION_MODAL:
			return {
				...state,
				...data,
			};
		default:
			return state;
	}
}
